module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 2
// module chunks = 0 1